import { isNil } from 'lodash'
import { time2Pixel } from '~/Util'
import { normalizePlaceholderBorders } from './normalizePlaceholderBorders'

export const getPlaceHolderIntersection = ({
  placeholdersByLayerIndex,
  dragItem,
  layerIds,
  offsetLayerIndex,
  scale,
  draggableBlockStartTime,
  draggableAssets,
  overNewLayerIndex,
  isExternalSource,
  draggableBlockDuration,
  clientMousePosition,
}) => {
  const startLayerIndex = isExternalSource ? 0 : layerIds.indexOf(dragItem.layerId)
  const currentDragItemLayerId = layerIds[startLayerIndex + offsetLayerIndex]

  const insertableDragAssets = draggableAssets
    .filter(a => a.layerId === dragItem.layerId).sort((a, b) => a.startTime - b.startTime)

  const start = insertableDragAssets?.[0]?.startTime ?? 0
  const finish = insertableDragAssets.at(-1)?.endTime ?? 0
  // dragLayerDuration - the length of the inserted area in the context of one layer
  const dragLayerDuration = isExternalSource ? draggableBlockDuration : finish - start

  return Object.values(placeholdersByLayerIndex ?? {})
    .reduce((result, placeholders) => {
      const { intersectionPlaceholder, intersectionEqualSegment, insertBetween } = placeholders
        .reduce((res, placeholder) => {
          const result = { ...res }
          const {
            placeholderEndTime, placeholderStartTime,
          } = normalizePlaceholderBorders(placeholder)

          if (isNil(overNewLayerIndex) && placeholder.layerId === currentDragItemLayerId) {
            if ((Math.round(placeholder.duration) < Math.round(dragLayerDuration))
              && (clientMousePosition >= placeholderStartTime
                && clientMousePosition <= placeholderEndTime)) {
              if (placeholder.duration === 0) {
                result.insertBetween = placeholder
              } else {
                result.intersectionPlaceholder = placeholder
              }
            }

            // for equal duration: placeholder & dragLayerDuration
            if ((Math.round(placeholder.duration) === Math.round(dragLayerDuration))
              && (clientMousePosition >= placeholderStartTime
                && clientMousePosition <= placeholderEndTime)) {
              result.intersectionEqualSegment = placeholder
            }
          }

          return result
        }, { intersectionPlaceholder: null, intersectionEqualSegment: null, insertBetween: null })

      let offsetDragItemFromZero = 0
      if ((intersectionPlaceholder?.startTime === 0 || insertBetween?.startTime === 0)
        && draggableBlockStartTime <= 0) {
        offsetDragItemFromZero = dragItem.startTime - draggableAssets?.[0]?.startTime
      }

      if (intersectionPlaceholder) {
        // eslint-disable-next-line no-param-reassign
        result = {
          intersectionPlaceholder,
          deltaOnDrop: time2Pixel(
            dragLayerDuration - intersectionPlaceholder.duration + offsetDragItemFromZero, scale
          ),
        }
      }
      if (insertBetween) {
        // eslint-disable-next-line no-param-reassign
        result = {
          insertBetween,
          deltaOnDrop: time2Pixel(
            dragLayerDuration - insertBetween.duration + offsetDragItemFromZero, scale
          ),
        }
      }
      if (intersectionEqualSegment) {
        // eslint-disable-next-line no-param-reassign
        result.intersectionEqualSegment = intersectionEqualSegment
      }
      return result
    }, {
      intersectionPlaceholder: null,
      intersectionEqualSegment: null,
      insertBetween: null,
      deltaOnDrop: 0,
    })
}
